import Swal from "sweetalert2";
import { Apis } from "../../lib/Apis";

export const homeScreenData = () => {
  const getHomeScreenData = async (setHomeScreen) => {
    try {
      const response = await Apis.getHomeScreenData();
      const payload = response?.data?.data || {};
      setHomeScreen(payload);
      return payload;
    } catch (error) {
      console.error("Error fetching home screen data:", error);
      return null;
    }
  };

  const postHomeScreenData = async (data) => {
    try {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });
      const response = await Apis.postHomeScreenData(formData);
      return response?.data;
    } catch (error) {
      console.error("Error adding home screen data:", error);
      throw new Error(
        error?.response?.data?.message ||
          error.message ||
          "Failed to add home screen item.",
      );
    }
  };

  const updateHomeScreenData = async (id, data) => {
    try {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });
      const response = await Apis.updateHomeScreenData(id, formData);
      return response?.data;
    } catch (error) {
      console.error("Error updating home screen data:", error);
      throw new Error(
        error?.response?.data?.message ||
          error.message ||
          "Failed to update home screen item.",
      );
    }
  };

  const deleteHomeScreenData = async (id) => {
    try {
      const response = await Apis.deleteHomeScreenData(id);
      return response?.data;
    } catch (error) {
      console.error("Error deleting home screen data:", error);
      throw new Error(
        error?.response?.data?.message ||
          error.message ||
          "Failed to delete home screen item.",
      );
    }
  };

  const getHomeScreenTypes = async () => {
    try {
      const response = await Apis.getHomeScreenTypes();
      return response?.data?.data || [];
    } catch (error) {
      console.error("Error fetching home screen types:", error);
      return [];
    }
  };

  const getHomeScreenSubTypes = async (typeId) => {
    try {
      if (!typeId) return [];
      const response = await Apis.getHomeScreenSubTypes(typeId);
      return response?.data?.data || [];
    } catch (error) {
      console.error("Error fetching home screen sub types:", error);
      return [];
    }
  };

  return {
    getHomeScreenData,
    postHomeScreenData,
    updateHomeScreenData,
    deleteHomeScreenData,
    getHomeScreenTypes,
    getHomeScreenSubTypes,
  };
};
